<div class="item-container" (click)="gotoInspectionReport()" [class.shared-lock]="isLocked">
  <div class="group larger">
    <img
      [style.display]="report.status !== '900' ? 'visible' : 'none'"
      src="assets/icons/sprite/report_editing.svg"
      class="editing-report-icon"
      alt="Editing Report Icon"
    />
    <img
      [style.display]="report.status === '900' ? 'visible' : 'none'"
      src="assets/icons/sprite/report_completed.svg"
      class="completed-report-icon"
      alt="Completed Report Icon"
    />
    <span class="text title" [matTooltip]="report.title" matTooltipPosition="above">{{ report.title }}</span>
  </div>

  <div class="group in-use">
    <evc-status-indicator
      *ngIf="isLocked && !isSharedLockByCurrentUser"
      text="IN USE"
      status="error"
      class="shared-lock"
      matTooltipPosition="above"
      [matTooltip]="getUserName()"
    />
    <evc-status-indicator
      *ngIf="isSharedLockByCurrentUser"
      status="info"
      class="shared-lock"
      icon="arrow-down-to-bracket"
      matTooltipPosition="above"
      [matTooltip]="getUserName()"
    />
    <div *ngIf="!isLocked"></div>
  </div>

  <div class="group date">
    <span class="text" [matTooltip]="report?.lastUpdateDate | date: 'yyyy-MM-dd'" matTooltipPosition="above">{{
      report?.lastUpdateDate | date: "yyyy-MM-dd"
    }}</span>
  </div>

  <div class="group inspector">
    <mat-icon class="user-icon">person_outline</mat-icon>
    <span class="text" [matTooltip]="report.createdBy | userNamePipe: tenantUsers" matTooltipPosition="above">
      {{ report.createdBy | userNamePipe: tenantUsers }}
    </span>
  </div>

  <div *ngIf="menuEnabled()" class="group menu-container">
    <button mat-icon-button *ngIf="!isReadOnly()" [matMenuTriggerFor]="MatMenu" (click)="$event.stopPropagation()">
      <mat-icon class="open-list-item-menu">more_vert</mat-icon>
    </button>
    <mat-menu class="three-dot-menu" #MatMenu>
      <button mat-menu-item (click)="editDelete()">
        {{ "inspectionlist.delete" | translate }}
      </button>
    </mat-menu>
  </div>

  <div *ngIf="!menuEnabled()" #noMenu class="group menu-container"></div>
</div>
